import { render } from "./oncology_procedures.vue?vue&type=template&id=6ae1d3ab&scoped=true"
import script from "./oncology_procedures.vue?vue&type=script&lang=js"
export * from "./oncology_procedures.vue?vue&type=script&lang=js"

import "./oncology_procedures.vue?vue&type=style&index=0&id=6ae1d3ab&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae1d3ab"]])

export default __exports__